module.exports = __webpack_public_path__ + "static/img/2noise_gate-1.de78367.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls37-1/2noise_gate-1.png
// module id = VJ4/
// module chunks = 12